import React from 'react';
import { useTranslation } from 'react-i18next';
import DriverAppSVG from '/src/components/driver-app';
import { DriverAppSVGMobile } from '/src/images/home';

const DriverApp = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.driver-app' });

	return (
		<section id="driver-app">
			<div>
				<div className="header">
					<h1>{t('hello-ai-copilot')}</h1>
					<h1>{t('transforming-safety')}</h1>

					<h2>{t('inclusive-technology')}</h2>
				</div>	

				<div className="img-wrapper">
					<DriverAppSVG />
					<img className="app-img mobile-screen" src={DriverAppSVGMobile} alt={t('say-hello-to-driver')} />
				</div>	

				<div className="bottom-wrapper">
					{/* <h2>{t('take-your-phone')}</h2> */}

					<div className="content-wrapper">
						<div className="inner-wrapper">
							<span className="underline">{t('three-million-plus')}</span>
							<span>&nbsp;</span>

							<div className="popup-wrapper">
								<div className="popup">
									<p>{t('in-twenty-nineteen')}</p>

									<a href="https://cdan.nhtsa.gov/tsftables/tsfar.htm" target="_blank" rel="noreferrer">{t('national-highway-traffic-safety-administration')}</a>
									<a href="https://www.zendrive.com/blog/2019-distracted-driving-study" target="_blank" rel="noreferrer">{t('zendrive')}</a>
								</div>
							</div>
						</div>

						<span>{t('vehicle-accidents')}&nbsp;</span>
						<span className="semibold">{t('we-want-to-change-that')}</span>

					</div>
				</div>
			</div>
		</section>
	);
};

export default DriverApp;
